// Where the agent's listings live: /agent/properties lists them, and each listing is the
// property page at /agent/properties/<id> (the seller's /my-property/<id> page, for the agent),
// with its pages under it (App.js; docs/agent-feature-audit.md section 15).

export const LIST_PATH = '/agent/properties';

/** The workspace views; 'overview' is the index route, the property page. */
export const WORKSPACE_VIEWS = ['overview', 'photos', 'marketing', 'cma', 'details'];

/**
 * The seller's pages of a property (the part after /my-property/<id>; 'overview' is the property
 * page itself) and the agent's page for each: an agent sent to a seller page opens the agent's.
 */
export const SELLER_PAGE_VIEWS = {
  overview: 'overview',
  details: 'details',
  media: 'photos',
  similar: 'cma',
  marketing: 'marketing',
  journey: 'overview',
};

/** A seller page of a property: sellerPagePath(12, 'similar') -> '/my-property/12/similar'. */
export const sellerPagePath = (propertyId, page = 'overview') => {
  const base = `/my-property/${encodeURIComponent(String(propertyId))}`;
  return page && page !== 'overview' ? `${base}/${page}` : base;
};

/** '/agent/properties/12' for the overview, '/agent/properties/12/cma' for a view. */
export const workspacePath = (propertyId, view = 'overview') => {
  const base = `${LIST_PATH}/${encodeURIComponent(String(propertyId))}`;
  return view && view !== 'overview' ? `${base}/${view}` : base;
};

/** The view a workspace URL shows: '/agent/properties/12/cma' -> 'cma', the index -> 'overview'. */
export const viewFromPath = (pathname) => {
  const parts = String(pathname || '').split('/').filter(Boolean);
  // ['agent', 'properties', '<id>', '<view>']
  const view = parts[3];
  return WORKSPACE_VIEWS.includes(view) ? view : 'overview';
};

/** The list URL with its filters: listPath({ status: 'sold', q: 'oak' }) -> '/agent/properties?status=sold&q=oak'. */
export const listPath = ({ status, q, page } = {}) => {
  const params = new URLSearchParams();
  if (status && status !== 'all') params.set('status', status);
  if (q) params.set('q', q);
  if (page && page > 1) params.set('page', String(page));
  const query = params.toString();
  return query ? `${LIST_PATH}?${query}` : LIST_PATH;
};

/**
 * "Add a property": the step-by-step page (pages/AddPropertyPage), the agent's here and the
 * homeowner's at SELLER_NEW_PROPERTY_PATH; each opens the new property at its own URL.
 */
export const NEW_PROPERTY_PATH = `${LIST_PATH}/new`;
export const SELLER_NEW_PROPERTY_PATH = '/my-property/new';
